import { ReactNode,useState } from 'react';

import { DataModelAttribute } from '@/types/DataModel';

import { FocusAttributeContext } from './FocusAttributeContext';

interface FocusAttributeProviderProps {
  children: ReactNode;
}

export const FocusAttributeProvider = ({ children }: FocusAttributeProviderProps) => {
    const [focusAttribute, setFocusAttribute] = useState<DataModelAttribute | undefined>(undefined);
    const [sectionOpen, setSectionOpen] = useState(false);

    return (
        <FocusAttributeContext.Provider value={{ focusAttribute, setFocusAttribute, sectionOpen, setSectionOpen }}>
            {children}
        </FocusAttributeContext.Provider>
    );
};

